import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Switch from '@material-ui/core/Switch'
import Divider from '@material-ui/core/Divider'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import ColorPickerComponent from 'routes/Admin/components/CommonComponents/ColorPickerComponent'
import {
  tableTypesMatcher,
  pricingTypesMatcher,
  pricingTypesShortMatcher
} from 'utils/labelMatcher'
const styles = theme => ({
  formControl: {
    // margin : `0 ${theme.spacing.unit}px`
  },
  group: {
    margin: `${theme.spacing.unit}px 0`
  }
})

class PricingModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    pricing: PropTypes.object,
    updatePricing: PropTypes.func,
    createPricing: PropTypes.func,
    tableTypes: PropTypes.object,
    pricingNames: PropTypes.array,
    hideModal: PropTypes.func
  }
  static defaultProps = {
    pricingNames: []
  }
  state = {
    pricing: {
      name: '',
      type: 0,
      isPlanned: false,
      color: '',
      rate: '0'
    },
    isValid: false,
    errors: {}
  }
  updateState = nextState => {
    const { pricing } = nextState
    const pricingProps = this.props.pricing
    let isValid = true
    let errors = {}
    if (
      !pricingProps &&
      this.props.pricingNames.includes(_.lowerCase(pricing.name))
    ) {
      isValid = false
      errors.name = 'Un autre tarif existe déjà avec ce nom'
    }
    if (pricing.type === '') {
      isValid = false
      errors.type = 'Ce champs est requis'
    }
    Object.keys(this.props.tableTypes).map(key => {
      if (key === 'key') return null
      if ((pricing[key] === '' || pricing[key].includes('-')) && isValid) {
        isValid = false
        errors[key] = `La valeur n'est pas valide`
      }
      return null
    })
    if (pricingProps && isValid) {
      isValid = !_.isEqual(pricingProps, pricing)
    }
    this.setState({ ...nextState, isValid, errors })
  }
  handleChange = name => (e, val) => {
    const isChecker = e.target.value === 'checker'
    let value = isChecker ? e.target.checked : val || e.target.value
    this.updateState({
      ...this.state,
      pricing: { ...this.state.pricing, [name]: value }
    })
  }
  handleColorSelection = name => color => {
    this.updateState({
      ...this.state,
      pricing: { ...this.state.pricing, [name]: color }
    })
  }

  handleOnCreate = () => {
    const { pricing } = this.state
    this.props.createPricing(pricing)
  }
  handleOnUpdate = () => {
    const { pricing } = this.state
    this.props.updatePricing(this.props.pricing, pricing)
  }
  formComponents = tableTypes => {
    const { classes } = this.props
    const { pricing, errors } = this.state
    const tableTypesEnabled = Object.keys(tableTypes).filter(
      key => tableTypes[key]
    )
    const endAdornmentLabel = pricingTypesShortMatcher(pricing.type)
    const components = tableTypesEnabled.map(key => {
      if (key === 'key') return null
      const label = tableTypesMatcher(key)
      return (
        <Grid key={key} item xs={12} sm={12} md={6}>
          <FormControl error={!!errors[key]} className={classes.formControl}>
            <InputLabel htmlFor={`${key}-input`}>{label}</InputLabel>
            <Input
              id={`${key}-input`}
              value={pricing[key]}
              onChange={this.handleChange(key)}
              type="number"
              inputProps={{ min: '0' }}
              endAdornment={
                <InputAdornment position="end">
                  {endAdornmentLabel}
                </InputAdornment>
              }
            />
            <FormHelperText>{errors[key] ? errors[key] : null}</FormHelperText>
          </FormControl>
        </Grid>
      )
    })
    return components
  }
  planningSwitch = classes => {
    const { pricing } = this.state
    return (
      <FormControlLabel
        control={
          <Switch
            checked={pricing.isPlanned}
            onChange={this.handleChange('isPlanned')}
            value="checker"
            color="primary"
          />
        }
        label="Planning"
      />
    )
  }
  colorPicker = classes => {
    const { pricing } = this.state
    return (
      <ColorPickerComponent
        className={classes.colorControl}
        colorValidate={this.handleColorSelection('color')}
        color={pricing.color}
      />
    )
  }
  selectTypePricing = classes => {
    const { pricing } = this.state
    return (
      <Grid
        item
        container
        direction="row"
        alignItems="flex-start"
        justify="space-between">
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth className={classes.formControl}>
            <InputLabel htmlFor="pricing-type">Type</InputLabel>
            <Select
              value={pricing.type}
              onChange={this.handleChange('type')}
              inputProps={{
                name: 'type',
                id: 'pricing-type'
              }}>
              <MenuItem value={0}>{pricingTypesMatcher(0)}</MenuItem>
              <MenuItem value={1}>{pricingTypesMatcher(1)}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    )
  }
  componentDidMount() {
    const { pricing, tableTypes } = this.props
    let nextState = { ...this.state }
    if (pricing) {
      nextState = { pricing: { ...pricing } }
    }
    if (tableTypes && !pricing) {
      Object.keys(tableTypes).map(key => {
        if (key === 'key') return null
        nextState.pricing[key] = '0.00'
        return null
      })
    }

    this.updateState(nextState)
  }
  render() {
    const { classes, tableTypes } = this.props
    const { errors, isValid, pricing } = this.state
    const isCreate = !this.props.pricing
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={isCreate ? this.handleOnCreate : this.handleOnUpdate}
        title={isCreate ? 'Ajouter un tarif' : `Editer ${pricing.name}`}
        okDisabled={!isValid}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between">
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="name"
                error={!!errors.name}
                helperText={errors.name || null}
                required
                label="Nom"
                disabled={!isCreate && _.lowerCase(pricing.name) === 'normal'}
                onChange={this.handleChange('name')}
                value={pricing.name}
                fullWidth
              />
            </Grid>
            {this.selectTypePricing(classes)}
            <Grid item xs={12} sm={12} md={8}>
              {this.planningSwitch(classes)}
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              {this.colorPicker(classes)}
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="center"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} hidden={{ mdUp: true }}>
              <Divider />
            </Grid>
            {this.formComponents(tableTypes).map(comp => comp)}
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(PricingModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Pricings/components/PricingModal.js